<template>
  <div class="forecast-step">
    <b-row class="e-lock-tokens">
      <b-col cols="4">
        <div class="d-flex align-items-center justify-content-center mb-3 mt-2 eh-text-small eh-text-gray-dark">
          <span><i class="far fa-credit-card mr-1"></i>Max. 15,000 EMiX</span>
          <span class="ml-auto">Balance: <a href="#" class="font-weight-bold pl-1" @click="onBalanceClick">{{ balance }} EMiX</a></span>
        </div>
        <b-form-input v-model="tokens"
                      type="number"
                      min="0"
                      :max="balance"
        >
        </b-form-input>
        <div class="d-flex align-items-center mt-3 eh-text-small eh-text-gray-dark">
          <span class="text-uppercase font-weight-bold"><i class="fas fa-lock mr-1"></i>Locked for 1 week</span>
        </div>
        <e-hint class="lock-tokens-hint" title="Notice">Please be informed that the tokens you choose to lock will be locked for a 1 Week (AKA 7 Days) After one week you'r token will return to you ewallet and after that you'll be inform if you were rewarded on you moderation or not.</e-hint>
      </b-col>
      <b-col cols="7" offset="1">
        <div class="modal-block-title">Read and Accept the rules2</div>
        <div class="rules">
          <div class="rules-wrapper">
            <p>Ten years ago a crack commando until was sent to prison by a military count for a crime they didn't commit. These men promptly escaped from a maximum security stockade to the Los Angeles underground. Today, still wanted by the goverment, they survive as soldiers of fortune. If you have a problem and no one else can help, and if you can find them, maybe you can hire the A-team. Ten years ago a crack commando until was sent to prison by a military count for a crime they didn't commit.</p>
            <p>These men promptly escaped from a maximum security stockade to the Los Angeles underground. Today, still wanted by the goverment, they survive as soldiers of fortune. If you have a problem and no one else can help, and if you can find them, maybe you can hire the A-team.</p>
            <p>Ten years ago a crack commando until was sent to prison by a military count for a crime they didn't commit. These men promptly escaped from a maximum security stockade to the Los Angeles underground. Today, still wanted by the goverment, they survive as soldiers of fortune. If you have a problem and no one else can help, and if you can find them, maybe you can hire the A-team.</p>
          </div>
        </div>

        <b-form-checkbox v-model="rules"
                        :value="true"
                        :unchecked-value="false"
                        class="mt-4 legacy-checkbox"
        >
          I accept the rules
        </b-form-checkbox>
      </b-col>
    </b-row>
    <div class="modal-footer">
      <e-button type="outlined" color="gray" @click="cancel">Cancel</e-button>        
      
      <div class="d-flex ml-auto">
        <e-button type="outlined" @click="preview" style="margin-right: 20px">Back</e-button>                
        <e-button :disabled="isDisabledNext" @click="next">Submit Forecast</e-button>        
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions, mapState, mapMutations } from "vuex";
import moment from 'moment';

export default {
  name: "step-lock-tokens",
  components: { },
  data() {
    return {};
  },
  methods: {
    ...mapMutations('forecast', {
      setLockedTokens: 'setLockedTokens',
      setAcceptedRules: 'setAcceptedRules'
    }),
    onBalanceClick() {
      this.tokens = this.balance > this.maxLockTokens ? this.maxLockTokens : this.balance;
    },
    cancel() {
      this.$emit('closeModal');
    },
    next() {
      this.$emit('nextPage');
    },
    preview() {
      this.$emit('previewPage');
    },
  },
  computed: {
    ...mapGetters('forecast', {
        lockedTokens: 'lockedTokens',
        acceptedRules: 'acceptedRules'
    }),
    ...mapGetters('auth', {
        balance: 'balance'
      }),
      tokens: {
        get() {
          return this.lockedTokens;
        },
        set(v) {
          this.setLockedTokens(parseFloat(v));
        }
      },
      rules: {
        get() {
          return this.acceptedRules;
        },
        set(v) {
          this.setAcceptedRules(v);
        }
      },
      isDisabledNext() {
        return this.tokens === 0 || this.acceptedRules === false;
      }
  },
  mounted() {
    // this.fetchCoins();
  }
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/modals/forecast/stepLockTokens.vue